const values = [
  "hero_alchemist_musketter",
  "hero_angelwings",
  "hero_angelwings_awaken",
  "hero_angelwings_infernal",
  "hero_angelwings_teotl",
  "hero_avalanchesurfer",
  "hero_avalanchesurfer_cloudrider",
  "hero_avalanchesurfer_poolparty",
  "hero_avalanchesurfer_star",
  "hero_bearchief",
  "hero_bearchief_awaken",
  "hero_bearchief_naval",
  "hero_beemistress",
  "hero_beemistress_awaken",
  "hero_beemistress_thief",
  "hero_beetlewarrior",
  "hero_beetlewarrior_awaken",
  "hero_beetlewarrior_pool",
  "hero_centaurarcher",
  "hero_centaurarcher_awaken",
  "hero_centaurarcher_dryad",
  "hero_chosengirl",
  "hero_chosengirl_grandmaster",
  "hero_chosengirl_priestess",
  "hero_cloudrabbit",
  "hero_cloudrabbit_awaken",
  "hero_cloudrabbit_tiger",
  "hero_cloudviking",
  "hero_cloudviking_awaken",
  "hero_cloudviking_dieselpunk",
  "hero_crazyalchemist",
  "hero_deathknight",
  "hero_deathknight_awaken",
  "hero_deathknight_star",
  "hero_dragoon_gm6",
  "hero_dragoon_star",
  "hero_dryad",
  "hero_dryad_awaken",
  "hero_dryad_chef",
  "hero_dryad_tropical",
  "hero_evilwings",
  "hero_evilwings_poolparty",
  "hero_evilwing_swampwitch",
  "hero_flamegoddess",
  "hero_flamegoddess_awaken",
  "hero_flamegoddess_catgirl",
  "hero_flamethrower",
  "hero_flamethrower_awaken",
  "hero_flamethrower_firewoman",
  "hero_flamethrower_landscaper",
  "hero_foreseer",
  "hero_foreseer_awaken",
  "hero_foreseer_citizen",
  "hero_hercules",
  "hero_hercules_awaken",
  "hero_hercules_mafia",
  "hero_iceMage",
  "hero_icemage_dapper",
  "hero_lastdragoon",
  "hero_last_dragoon_musketeer",
  "hero_lavachef",
  "hero_lavachef_awaken",
  "hero_lavachef_eaglewarrior",
  "hero_lavachef_skinwitch",
  "hero_lionking",
  "hero_lionking_awaken",
  "hero_lionking_bbqchef",
  "hero_lionking_boxer",
  "hero_mefolkfighter_maskedheroine",
  "hero_merfolk_dapper",
  "hero_merfolk_fighter",
  "hero_merfolk_poolparty",
  "hero_ramhammer",
  "hero_ramhammer_grandvizier",
  "hero_ramhammer_piratelord",
  "hero_reaper",
  "hero_reaper_awaken",
  "hero_reaper_infernal",
  "hero_reaper_spades",
  "hero_ronin",
  "hero_ronin_awaken",
  "hero_ronin_miku",
  "hero_ronin_surgingriver",
  "hero_sandscorpion",
  "hero_sandscorpion_awaken",
  "hero_sandscorpion_tribal",
  "hero_smith",
  "hero_smith_gm6",
  "hero_smith_grandmaster",
  "hero_smith_infernal",
  "hero_toadshaman",
  "hero_toadshaman_awaken",
  "hero_toadshaman_pirate",
  "hero_windknight",
  "hero_windknight_gm6",
  "hero_windknight_grandmaster",
  "hero_windknight_maskedherione",
  "hero_windknight_musketeer",
  "hero_windknight_star",
  "hero_wolfhuntress",
  "hero_wolfhuntress_awaken",
  "hero_wolfhuntress_woodlands",
  "hero_yeti",
  "hero_yeti_dapper",
  "hero_yeti_shortstop",
  "herp_wolfhuntress_maskedheroine",
  "item_gold",
  "spell_angelic_host",
  "spell_bolster",
  "spell_breathoffire",
  "spell_bubbleblast",
  "spell_castthebones",
  "spell_consecrate",
  "spell_darksummons",
  "spell_desecrate",
  "spell_divinecommand",
  "spell_dynastinae",
  "spell_fireball",
  "spell_fire_trap",
  "spell_focus_fire",
  "spell_frost_trap",
  "spell_fungalbloom",
  "spell_giftofkinahau",
  "spell_greed_cannon",
  "spell_holy_nova",
  "spell_howlingblast",
  "spell_ice_rupture",
  "spell_judgement",
  "spell_lightningbolt",
  "spell_magmafall",
  "spell_manastorm",
  "spell_mightofyaoga",
  "spell_polybomb",
  "spell_rallycry",
  "spell_salvo",
  "spell_skywindsaga",
  "spell_spikedbarricade",
  "spell_thunder_wave",
  "spell_treants",
  "spell_typhoon",
  "spell_vine_lash",
  "spell_warbots",
  "tower_arcane",
  "tower_arrow",
  "tower_axemantower",
  "tower_barrack",
  "tower_beetletower",
  "tower_bigheadtower",
  "tower_cannon",
  "tower_catapulttower",
  "tower_centaurbarracks",
  "tower_cloudtower",
  "tower_crusader",
  "tower_darkportal",
  "tower_dragoonbarracks",
  "tower_druid",
  "tower_flame_cannon",
  "tower_frost",
  "tower_huntershut",
  "tower_iceman",
  "tower_lavaooze",
  "tower_leviathan",
  "tower_lighthouse",
  "tower_merman",
  "tower_mummybarracks",
  "tower_oiltower",
  "tower_planttower",
  "tower_potiondealer_tower",
  "tower_repeater",
  "tower_scorcher",
  "tower_stoneguard",
  "tower_sunsanctum",
  "tower_tesla",
  "tower_warlocktower",
];
export default values;
